import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Overlooks Mumbai’s largest 90-acre golf course",
    "Spacious private decks with uninterrupted green views",
    "2 apartments per floor & 3 elevators per tower",
    "2.98 acres of open spaces & lush central greens",
  ];
  const highlights2 = [
    "Over 700 trees for a cooler, greener environment",
    "Clubhouse with thoughtfully appointed amenities",
    "Fully air-conditioned homes with sundecks",
    "Staff quarters with each residence",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Welcome to Rustomjee Balmoral Chembur Golf Links, a landmark residential
        address adjoining Mumbai’s largest golf course. Located in the heart of
        Chembur, this exclusive gated community offers a lifestyle rarely found
        in the city—where serenity, stillness, and sophistication co-exist.
        <br />
        Crafted by Hafeez Contractor, Patty Mak, and COEN, every residence
        offers expansive golf course views, spacious sundecks, and calming green
        surrounds. With just two apartments per floor, curated ground-level
        amenities, and lush open spaces, Rustomjee Balmoral Golf Links isn’t
        just a home—it’s a perspective on life where luxury whispers and peace
        lingers.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
